/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { InvitationsControllerRemoveMutationResponse, InvitationsControllerRemovePathParams, InvitationsControllerRemoveQueryParams, InvitationsControllerRemove400, InvitationsControllerRemove401, InvitationsControllerRemove403, InvitationsControllerRemove404 } from "../../models/invitationsController/InvitationsControllerRemove";

function getInvitationsControllerRemoveUrl(id: InvitationsControllerRemovePathParams["id"]) {
  const res = { method: 'DELETE', url: `/api/v1/invitations/${id}` as const }  
  return res
}

/**
 * @description Revokes an existing invitation, preventing it from being used. Pass scopeId to revoke only that target scope; the invitation itself goes when its last target does.
 * @summary Revoke invitation
 * {@link /api/v1/invitations/:id}
 */
export async function invitationsControllerRemove(id: InvitationsControllerRemovePathParams["id"], params?: InvitationsControllerRemoveQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<InvitationsControllerRemoveMutationResponse, ResponseErrorConfig<InvitationsControllerRemove400 | InvitationsControllerRemove401 | InvitationsControllerRemove403 | InvitationsControllerRemove404>, unknown>({ method : "DELETE", url : getInvitationsControllerRemoveUrl(id).url.toString(), params, ... requestConfig })  
  return res.data
}